import useSWR, { SWRResponse } from 'swr'

import { PLATFORM } from '@/constants/platform'
import { useAuthStore } from '@/stores/useAuthStore'
import { StreamEvent } from '@/types/streams/event'
import { EventEncoderDetails } from '@/types/streams/eventEncoder'

import { DGE_ENDPOINTS } from './constants/dgeEndpoints'
import { fetchData } from './request'

export function useGetEvent(eventId?: string | number): SWRResponse<StreamEvent> {
  const platform = useAuthStore.getState().platform

  if (platform === PLATFORM.DGE) {
    return useSWR<StreamEvent>(
      eventId
        ? `${DGE_ENDPOINTS.Event.get(String(eventId))}?additionalDetails=true&useDeprecatedApi=true`
        : null,
      (endpointData) => fetchData<StreamEvent>({ endpointData }),
      { revalidateOnFocus: false }
    )
  }

  throw new Error('Unsupported platform')
}

export function useGetEventEncoderDetails(eventId?: string): SWRResponse<EventEncoderDetails> {
  const platform = useAuthStore.getState().platform

  if (platform === PLATFORM.DGE) {
    return useSWR<EventEncoderDetails>(
      eventId ? DGE_ENDPOINTS.Event.EncodeDetails.get(eventId) : null,
      (endpointData) => fetchData<EventEncoderDetails>({ endpointData }),
      { revalidateOnFocus: false }
    )
  }

  throw new Error('Unsupported platform')
}
